import ColorCell from './ColorCell';

export default ColorCell;
